import { BrowserStorage } from '@utils/BrowserStorage';

export class BotAvatarService {
  private readonly avatarKey = 'avatar';

  private browserStorage = new BrowserStorage(this.avatarKey);

  public get avatar(): string {
    return this.browserStorage.getObject(this.avatarKey);
  }

  public initializeOrUpdate(avatar: string) {
    this.browserStorage.setObject(this.avatarKey, avatar);
  }

  public clear() {
    this.browserStorage.clear();
  }
}
